import { createAction, createAsyncAction } from 'typesafe-actions';
import { UserInfo, UserModalType, GetUsersParams, CreateUserPayload, UpdateUserPayload } from './types';

export const getUsersAsync = createAsyncAction(
  'users/GET_USERS_REQUEST',
  'users/GET_USERS_SUCCESS',
  'users/GET_USERS_FAILURE',
)<GetUsersParams, { total: number; data: any[] }, Error>();

export const updateUserAsync = createAsyncAction(
  'users/UPDATE_USER_REQUEST',
  'users/UPDATE_USER_SUCCESS',
  'users/UPDATE_USER_FAILURE',
)<UpdateUserPayload, {}, Error>();

export const addUserAsync = createAsyncAction(
  'users/ADD_USER_REQUEST',
  'users/ADD_USER_SUCCESS',
  'users/ADD_USER_FAILURE',
)<CreateUserPayload, {}, Error>();

export const setUsers = createAction('users/SET_USERS')<Array<UserInfo>>();
export const setRefreshTable = createAction('users/SET_REFRESH_TABLE')<boolean>();
export const setOpenUserModal = createAction('users/SET_OPEN_USER_MODAL')<UserModalType>();
